"use client";
import React, {
  createContext,
  useState,
  ReactNode,
  useContext,
  useEffect,
} from "react";

interface ChatContextProps {
  chatModal: boolean;
  setChatModal: (_visible: boolean) => void;
  notificationsList: any[];
  setNotificationsList: (_visible: any[]) => void;
}

const ChatContext = createContext<ChatContextProps | undefined>(undefined);

export const ChatProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [chatModal, setChatModal] = useState<boolean>(false);
  const [notificationsList, setNotificationsList] = useState<any[]>([]);
  return (
    <ChatContext.Provider
      value={{
        chatModal,

        setChatModal,
        notificationsList,
        setNotificationsList,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error("useChat must be used within a ChatProvider");
  }
  return context;
};
